import { render, staticRenderFns } from "./price_ratio_dialog.vue?vue&type=template&id=992637f2&scoped=true"
import script from "./price_ratio_dialog.vue?vue&type=script&lang=js"
export * from "./price_ratio_dialog.vue?vue&type=script&lang=js"
import style0 from "./price_ratio_dialog.vue?vue&type=style&index=0&id=992637f2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "992637f2",
  null
  
)

export default component.exports